// Recorrido 360°: precios y contacto. Un solo lugar para cambiarlos (la pestaña y el botón de WhatsApp los leen de acá).
export const PRECIO_MENSUAL = 'USD 200';
export const PRECIO_ALTA = 'USD 1.100';

// Cristian (ventas): el botón "Contratar servicio" abre su WhatsApp con el pedido escrito.
export const WHATSAPP_VENTAS = '5491132536065';

// Recorrido de ejemplo que se le muestra a quien todavía no tiene el servicio.
export const EJEMPLO_360 = 'https://editor.lisual.com/p/faesalta';

export const linkContratar = ({ obra, empresa, feedID }) => {
  const texto = [
    'Hola Cristian! Quiero contratar el servicio de Recorrido 360° para mi obra',
    obra ? `"${obra}"` : '',
    empresa ? `(${empresa})` : '',
    feedID ? `· cámara ${feedID}` : '',
  ].filter(Boolean).join(' ');
  return `https://wa.me/${WHATSAPP_VENTAS}?text=${encodeURIComponent(texto)}`;
};

// Página web (pestaña propia, al lado de Recorrido 360°): precio y web de ejemplo. Se pide por el mismo WhatsApp de ventas.
export const PRECIO_WEB = 'USD 3.200';
export const EJEMPLO_WEB = 'https://editor.lisual.com/p/absgaona';

export const linkPedirWeb = ({ obra, empresa, feedID, cambios }) => {
  const texto = [
    cambios ? 'Hola Cristian! Quiero hacer cambios en la página web de mi obra' : 'Hola Cristian! Quiero contratar la página web para mi obra',
    obra ? `"${obra}"` : '',
    empresa ? `(${empresa})` : '',
    feedID ? `· cámara ${feedID}` : '',
  ].filter(Boolean).join(' ');
  return `https://wa.me/${WHATSAPP_VENTAS}?text=${encodeURIComponent(texto)}`;
};
